// Defaults + option lists for the Training & Competency Management prototype. The
// org config overrides these at runtime; the built-in values keep the demo working
// out of the box (mirroring how the changeV2 mock ships built-in fallbacks).

// QM "Training records" page (query by employee / by document).
export const TRAINING_RECORDS_PATH = '/training';

export const TRAINING_BASE_DEFAULTS = {
  documentName: 'SOP-720 Production',
  revision: 'Revision C',
  reason: 'New document revision',
  trainingMethod: 'Read & acknowledge',
  targetFunctions: ['Production', 'Quality Assurance'],
  dueInDays: 14,
} as const;

// Selectable options in the "Assign training" dialog.
export const TRAINING_METHOD_OPTIONS = [
  'Read & acknowledge',
  'Classroom training',
  'On-the-job training',
  'Assessment / quiz',
];

export const TARGET_FUNCTION_OPTIONS = [
  'Production',
  'Quality Assurance',
  'Regulatory Affairs',
  'Research & Development',
  'Service & Maintenance',
  'Management',
];
